// extracted by mini-css-extract-plugin
export var black = "styles-module--black--6bd17";
export var container = "styles-module--container--3b56a";
export var green = "styles-module--green--89c7f";
export var transparent = "styles-module--transparent--3cb2a";
export var transparentBlack = "styles-module--transparentBlack--f8557";
export var transparentGreen = "styles-module--transparentGreen--7d9ed";
export var transparentWhite = "styles-module--transparentWhite--bba23";
export var white = "styles-module--white--cfa9d";